export const removeBuyerViewQueryParam = () => {
  if (typeof window === 'undefined') {
    return
  }

  const params = new URLSearchParams(window.location.search)

  if (params.get('view') !== 'buyer') {
    return
  }

  params.delete('view')
  const nextSearch = params.toString()
  const nextUrl = `${window.location.pathname}${nextSearch ? `?${nextSearch}` : ''}${window.location.hash}`

  window.history.replaceState(window.history.state, '', nextUrl)
}
